import React from 'react';
import { Globe } from 'lucide-react';
import { APP_CFG } from '@/configs';

export type ChannelOption = {
	channel: string; // Discord channel name
	label: React.ReactNode; // Supports plain text or a React element
	icon: React.ReactNode; // Optional icon element (e.g., Lucide icon)
};

const makeEnvAwareChannel = (baseName: string) => (APP_CFG.NETWORK !== 'mainnet' ? `${baseName}-${APP_CFG.NETWORK}` : baseName);

// Central list of available channels for chat
// The `channel` should match the Discord text channel name exactly.
export const CHANNELS: ChannelOption[] = [
	{
		channel: makeEnvAwareChannel('general-chat'),
		label: 'General',
		icon: <Globe className="aspect-square w-4" />,
	},
	// { channel: 'vip', label: 'VIP', icon: <Star className="aspect-square w-4" fill="red" /> },
];

export const DEFAULT_CHANNEL_OPTION = CHANNELS[0];

const channelMatchers = CHANNELS.map((option) => ({
	key: option.channel,
	lower: option.channel.toLowerCase(),
}));

export function isAvailableChannel(name?: string | null): boolean {
	if (!name) {
		return false;
	}
	const lower = name.toLowerCase();
	return channelMatchers.some((matcher) => lower === matcher.lower || lower.endsWith(matcher.lower));
}

/**
 * Normalizes a Discord channel name coming from the backend/WebSocket to the
 * frontend's canonical channel key. Discord channels can be prefixed with emojis
 * or categories (e.g. "🧑🏻‍💻┃chat-test"); we treat a suffix match as the same channel.
 */
export function canonicalChannelName(name?: string | null): string | undefined {
	if (!name) return undefined;
	const lower = name.toLowerCase();
	const match = channelMatchers.find((matcher) => lower === matcher.lower || lower.endsWith(matcher.lower));
	return match?.key ?? name;
}
